import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import { isEmpty } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import * as moment from "moment"
import {
  deleteOperatorProduct,
  getAllOperatorProducts,
  updateOperatorProduct,
} from "store/operatorProducts/actions"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import {API_URL, sitename} from "../../../constants/constants"
import {
  getTokenFromLocalStorage,
  hasPermission,
  showErrorMessages,
} from "helpers/helpers"
import { showMessage } from "../../../components/Common/Toaster"
import axios from "axios"

//redux
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getAllUsers } from "store/users/actions"
// import OperatorManagerProductsModal from "./OperatorManagerProductsModal"
import { getAllSuppliers } from "store/suppliers/actions"

const Suppliers = props => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getAllSuppliers())
  }, [])

  const Suppliers = useSelector(state => state.suppliers.Index ?? [])

  //pagination customization
  const pageOptions = {
    sizePerPage: 10,
    totalSize: Suppliers.length, // replace later with size(orders),
    custom: true,
  }
  const { SearchBar } = Search

  const toLowerCase1 = str => {
    return str.toLowerCase()
  }

  const handleAddSupplierClick = arg => {
    props.history.push("/supplier/create")
  }

  var node = useRef()

  const handleDelete = sp => {
    axios({
      method: "delete",
      url: `${API_URL}/admin/suppliers/${sp.id}`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
      },
    })
      .then(function (response) {
        dispatch(getAllSuppliers())
        showMessage("success", response.data.message)
      })
      .catch(function (response) {
        //handle error
        showErrorMessages(response)
      })
  }

  const handleEdit = (value, e) => {
    e.preventDefault()
    props.history.push(`${window.location.pathname}/edit?id=${value.id}`)
  }

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]

  const supplierProductsColumns = [
    {
      dataField: "id",
      text: "Supplier#",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => {
        return <p className="text-body fw-bold">{row.id}</p>
      },
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      formatter: (cellContent, row) => {
        return <p className="text-body fw-bold">{row.name}</p>
      },
    },
    {
      dataField: "name",
      text: "Commission",
      sort: true,
      formatter: (cellContent, row) => {
        return <p className="text-body fw-bold">{`${row.commision}%`}</p>
      },
    },

    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, supplier) => (
        <>
          <div className="d-flex gap-3">
            {hasPermission("update-supplier_commissions") && (
              <Link
                to="#"
                className="text-success"
                onClick={e => handleEdit(supplier, e)}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit
                </UncontrolledTooltip>
              </Link>
            )}
            {hasPermission("delete-supplier_commissions") && (
              <Link
                to="#"
                className="text-danger"
                onClick={() => handleDelete(supplier)}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Delete
                </UncontrolledTooltip>
              </Link>
            )}
          </div>
        </>
      ),
    },
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Settings" breadcrumbItem="Supplier Commissions" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={supplierProductsColumns}
                    data={Suppliers}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="id"
                        data={Suppliers}
                        columns={supplierProductsColumns}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="4">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              {hasPermission("create-supplier_commissions") && (
                                <Col sm="8">
                                  <div className="text-sm-end">
                                    <Button
                                      type="button"
                                      color="success"
                                      className="btn-rounded  mb-2 me-2"
                                      onClick={handleAddSupplierClick}
                                    >
                                      <i className="mdi mdi-plus me-1" />
                                      Add New
                                    </Button>
                                  </div>
                                </Col>
                              )}
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField="id"
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    // selectRow={selectRow}
                                    classes={
                                      "table align-middle table-nowrap table-check"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    ref={node}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Suppliers)
